<template>
	<v-sheet elevation="0">
		<CommonFlame :title="title" class="ma-2">
			<v-container class="d-flex justify-center align-center">
				<v-btn color="primary" class="mr-4" @click="goToTeamAllocation">チームへ割振</v-btn>
				<v-btn color="primary" @click="goToInternalAllocation">チーム内割振</v-btn>
			</v-container>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
export default {
	name: "OrderAllocationChoicePage",
	components: {
		CommonFlame,
	},
	data() {
		return {
			title: "製造オーダー割振",
		}
	},
	methods: {
		goToTeamAllocation() {
			this.$router.push({ name: "order_allocation_to_team" })
		},
		goToInternalAllocation() {
			this.$router.push({ name: "order_allocation_to_team_member" })
		},
	},
}
</script>
